import { textNodeToJsxPrinter, htmlNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { anchor } from './printer.anchor.style.js';
import { jsx } from 'react/jsx-runtime';

const printPrintableAnchorNode = (node, context) => {
  if (!node.children?.length) {
    return null;
  }
  return /*#__PURE__*/jsx("a", {
    href: node.href,
    className: anchor,
    children: context.printChildren(node.children, {
      html: htmlNodeToJsxPrinter,
      text: textNodeToJsxPrinter
    })
  }, generateJsxKey(context));
};

export { printPrintableAnchorNode };
//# sourceMappingURL=printer.anchor.js.map
